import { render, staticRenderFns } from "./RecurringCard.vue?vue&type=template&id=2848c067"
import script from "./RecurringCard.vue?vue&type=script&lang=js"
export * from "./RecurringCard.vue?vue&type=script&lang=js"
import style0 from "./RecurringCard.vue?vue&type=style&index=0&id=2848c067&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports